import classnames from "classnames";
import * as React from "react";
import { Link } from "react-router-dom";

import BackButtonWithText, {
  COLORS
} from "features/common/buttons/components/BackButtonWithText";
import PrimaryButton, {
  PrimaryButtonWithLink
} from "features/common/buttons/components/PrimaryButton";
import TextPlaceholder from "features/common/components/TextPlaceholder";

import styles from "./InnerModal.module.scss";

export type InnerModalProps = {
  title?: string;
  renderTitle?: () => React.ReactNode;
  subTitle?: string;
  renderSubTitle?: () => React.ReactNode;
  buttonText: string;
  overlayLink?: string;
  backButtonLink?: string;
  onPrimaryButtonClick?: () => void;
  isPrimaryButtonDisabled?: boolean;
  primaryButtonClassName?: string;
  primaryButtonClickTo?: string;
  cancelButton?: boolean;
  submitting?: boolean;
  loading?: boolean;
  errorMessage?: string | null | undefined;
  onCancelClick?: () => void;
  cancelButtonText?: string;
  primaryButtonType?: string[];
  innerModalClassName?: string;
  children?: React.ReactNode;
  backButtonText?: string;
};

export default class InnerModal extends React.PureComponent<InnerModalProps> {
  render() {
    const {
      title,
      renderTitle,
      subTitle,
      renderSubTitle,
      buttonText,
      overlayLink,
      backButtonLink,
      onPrimaryButtonClick,
      primaryButtonClickTo,
      isPrimaryButtonDisabled,
      primaryButtonClassName,
      cancelButton,
      submitting,
      loading,
      errorMessage,
      onCancelClick,
      cancelButtonText,
      primaryButtonType,
      innerModalClassName,
      backButtonText = "Back",
      children
    } = this.props;
    return (
      <div className={classnames(styles.innerModal, innerModalClassName)}>
        {backButtonLink && (
          <Link className={styles.backLink} to={backButtonLink} replace>
            {/* @ts-ignore */}
            <BackButtonWithText text={backButtonText} color={COLORS.BLACK} />
          </Link>
        )}
        <p className={styles.title}>
          <TextPlaceholder placeholderWidth="15em" loading={loading}>
            {renderTitle ? renderTitle() : title}
          </TextPlaceholder>
        </p>
        {(renderSubTitle || subTitle) && (
          <p className={styles.subTitle}>
            <TextPlaceholder placeholderWidth="10em" loading={loading}>
              {renderSubTitle ? renderSubTitle() : subTitle}
            </TextPlaceholder>
          </p>
        )}
        {children}
        <div className={styles.button}>
          {primaryButtonClickTo ? (
            <PrimaryButtonWithLink
              className={primaryButtonClassName}
              to={primaryButtonClickTo}
              onClick={onPrimaryButtonClick}
              text={buttonText}
              type={primaryButtonType}
              disabled={loading || isPrimaryButtonDisabled || submitting}
              loading={submitting}
            />
          ) : (
            <PrimaryButton
              className={primaryButtonClassName}
              onClick={onPrimaryButtonClick}
              text={buttonText}
              type={primaryButtonType}
              disabled={loading || isPrimaryButtonDisabled || submitting}
              loading={submitting}
            />
          )}
        </div>
        {cancelButton && onCancelClick ? (
          <div onClick={onCancelClick} className={styles.cancel}>
            {cancelButtonText || "Cancel"}
          </div>
        ) : (
          cancelButton &&
          overlayLink && (
            <Link className={styles.cancel} to={overlayLink} replace>
              {cancelButtonText || "Cancel"}
            </Link>
          )
        )}
        {errorMessage && (
          <div className={styles.error_message}>{errorMessage}</div>
        )}
      </div>
    );
  }
}
